export default __webpack_public_path__ + "static/media/CaptainAmericaShield.e709cdf0.jpeg";